import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import {
  CHART_AXIS,
  CHART_COLORS,
  CHART_TOOLTIP_ITEM_STYLE,
  CHART_TOOLTIP_STYLE,
} from './chart-theme';

export interface SignupsRow {
  date: string;
  daily: number;
  cumulative: number;
}

interface SignupsChartProps {
  data: SignupsRow[];
  height?: number;
}

const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'] as const;

function fmtDate(raw: string): string {
  const [, m, d] = raw.split('-');
  if (!m || !d) return raw;
  const idx = Math.max(0, Math.min(11, Number(m) - 1));
  return `${months[idx]} ${Number(d)}`;
}

export function SignupsChart({ data, height = 280 }: SignupsChartProps): JSX.Element {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <ComposedChart data={data} margin={{ top: 8, right: 12, bottom: 0, left: -12 }}>
        <CartesianGrid stroke={CHART_AXIS.stroke} vertical={false} />
        <XAxis
          dataKey="date"
          stroke={CHART_AXIS.stroke}
          tick={CHART_AXIS.tick}
          tickLine={false}
          tickFormatter={fmtDate}
          minTickGap={28}
        />
        <YAxis
          yAxisId="left"
          stroke={CHART_AXIS.stroke}
          tick={CHART_AXIS.tick}
          tickLine={false}
          axisLine={false}
          width={40}
          allowDecimals={false}
        />
        <YAxis
          yAxisId="right"
          orientation="right"
          stroke={CHART_AXIS.stroke}
          tick={CHART_AXIS.tick}
          tickLine={false}
          axisLine={false}
          width={48}
          allowDecimals={false}
        />
        <Tooltip
          contentStyle={CHART_TOOLTIP_STYLE}
          itemStyle={CHART_TOOLTIP_ITEM_STYLE}
          labelStyle={{ color: '#CCCCCC', fontWeight: 700 }}
          cursor={{ fill: 'rgba(255,255,255,0.04)' }}
          labelFormatter={fmtDate}
        />
        <Bar
          yAxisId="left"
          dataKey="daily"
          name="Daily signups"
          fill={CHART_COLORS[0]}
          radius={[4, 4, 0, 0]}
          maxBarSize={28}
          isAnimationActive={false}
        />
        <Line
          yAxisId="right"
          type="monotone"
          dataKey="cumulative"
          name="Cumulative total"
          stroke={CHART_COLORS[1]}
          strokeWidth={2}
          dot={false}
          isAnimationActive={false}
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
}
